<div class="no-data-container">
  <h3>{{header}}</h3>
  <h4 *ngIf="subheader">{{subheader}}</h4>
</div>
